import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import CookieBanner from 'components/CookieBanner';
import {Loader} from 'components/Loader';
import App from './App';
import Auth from './Auth';
import MobileView from './Auth/pages/MobileView';
import * as serviceWorker from './serviceWorker';

import firebase from './imports/utils/firebase';

class Root extends Component {
  state = {
    loading: true,
    user: null,
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      this.setState({user, loading: false});
    });
  }

  render() {
    const {loading, user} = this.state;
    if (loading) return <Loader />;

    return (
      <Router>
        <CookieBanner />
        <Switch>
          <Route
            path="/signin"
            render={() => {
              if (isMobile) {
                return <MobileView />;
              }
              return !user ? <Auth /> : <Redirect to="/" />;
            }}
          />
          <Route
            path="/signup"
            render={() => {
              if (isMobile) {
                return <MobileView />;
              }
              return !user ? <Auth /> : <Redirect to="/" />;
            }}
          />
          <Route
            path="/forgot-password"
            render={() => {
              if (isMobile) {
                return <MobileView />;
              }
              return !user ? <Auth /> : <Redirect to="/" />;
            }}
          />
          <Route path="/s/:strategyId/p/:pickId" render={() => (!user ? <Auth /> : <App />)} />
          <Route
            path="/"
            render={() => {
              if (isMobile) {
                return <MobileView />;
              }
              return user ? <App /> : <Redirect to="/signin" />;
            }}
          />
        </Switch>
      </Router>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();
